import styled from '@emotion/styled';

export const PdfPage = styled.div`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`;
